<template>
  <div class="video-popup" >
    <div class="video-content">
      <template v-if="!fullScreenPlay">
        <img v-show="!isShowVideo" :src="coverUrl" alt="">
        <video v-show="isShowVideo" :id="`myVideo_${bannerIndex}`"
               controls
               :poster="coverUrl"
               :src="videoUrl"
               controlsList="nodownload noremoteplayback noplaybackrate"
               playsinline
               x-webkit-airplay
               x5-video-player-type="h5"
               x5-videoplayer-fullscreen
               webkit-playsinline
               x5-video-orientation='portraint'
               style='object-fit:fill;'
               class="full-screen-video"
               @play="notFullScreenPlay"
               @ended="notFullScreenEnded"
        ></video>
        <div v-show="!notFullScreenVideoPlaying" class="videoPlayBtn" @click="onChangeVideoPlay">
          <img class="videoBtn" src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        </div>
      </template>
      <template v-else>
        <img v-show="!isShowVideo" :src="coverUrl" alt="">
        <video v-show="isShowVideo" :id="`myVideo_${bannerIndex}`" :controls="false" :src="videoUrl"
               @fullscreenchange="handleFullscreenChange"
               :poster="coverUrl"
               controlsList="nodownload noremoteplayback noplaybackrate"
               disablePictureInPicture
        ></video>
        <div class="videoPlayBtn" @click="onChangeVideoPlay">
          <img class="videoBtn" src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    videoUrl:{
      type: String,
      default: ''
    },
    coverUrl:{
      type: String,
      default: ''
    },
    bannerIndex:{
      type: String,
      default: ''
    },
    // 全屏播放
    fullScreenPlay: {
      type: Boolean,
      value: false
    },
    // 暂停全部播放
    pauseAllPlay: {
      type: Boolean,
      value: true
    },
    // 是否切换
    isChange: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isFullscreen: false,
      isShowVideo:false,
      notFullScreenVideoPlaying: false,
      videoPlayerFullScreen: null
    }
  },
  mounted() {
  },
  watch:{
    videoUrl(newValue){
      console.log('videoUrlvideoUrl',newValue)
    },
    isChange(val) {
      console.log(val)
      if(val) {
        this.notFullScreenVideoPlaying = false;
        this.isShowVideo = false;
      }
    }
  },
  methods:{
    // onChangeVideo(){
    //   const video = this.$refs.myVideo;
    //   const videoList = document.querySelectorAll('.video-content video')
    //   videoList.forEach(item=>{
    //     const src = item.getAttribute('src')
    //     if(src!==this.videoUrl){
    //       item.pause()
    //     }
    //   })
    //   if (video.paused) {
    //     this.onChangeVideoEmit()
    //     video.play()
    //   } else {
    //     video.pause()
    //   }
    // },
    //   全屏
    async fullScreen() {
      // 自动播放
      const video = document.getElementById(`myVideo_${this.bannerIndex}`);
      // 点击播放按钮重新添加视频url
      this.isShowVideo = true
      video.setAttribute('src',this.videoUrl)
      this.onChangeVideoEmit()
      await video.play();
      if (!this.isFullscreen) {
        await this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    },
    // 进入全屏逻辑
    async enterFullscreen() {
      const video = document.getElementById(`myVideo_${this.bannerIndex}`);
      await video.play()
      if (video.requestFullscreen) {
        await video.requestFullscreen();
      } else if (video.mozRequestFullScreen) { // Firefox
        await video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
        await video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) { // IE/Edge
        await video.msRequestFullscreen();
      }
    },
    // 退出全屏逻辑
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isFullscreen = false;
    },
    handleFullscreenChange() {
      // 更新全屏状态
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      if(!this.isFullscreen){
        this.isShowVideo = false
        this.$refs.myVideo.pause()
      //   清除视频显示出封面
        this.$refs.myVideo.setAttribute('src','')
      }
    },
    onChangeVideoPlay(){
      // this.isShowVideo = false
      // console.log('onChangeVideoPlay')
      if(this.fullScreenPlay) {
        this.fullScreen()
      } else {
        const video = document.getElementById(`myVideo_${this.bannerIndex}`);
        video.currentTime = 0;
        // video.setAttribute('src',this.videoUrl)
        // this.onChangeVideoEmit()
        // await video.play();
        // setTimeout(()=> {
        //
        // },100)
        setTimeout(()=> {
          this.notFullScreenVideoPlaying = true;
          this.isShowVideo = true;
          video.play();
        },200)
      }
    },
    // 播放视频触发事件
    onChangeVideoEmit(){
      this.$emit('onChangeVideo')
    },
    // 非全屏播放
    notFullScreenPlay() {
      this.notFullScreenVideoPlaying = true;
      this.isShowVideo = true;
    },
    notFullScreenEnded() {
      this.notFullScreenVideoPlaying = false;
      this.isShowVideo = false;
    }
  }
}
</script>
<style scoped lang="less">
.video-popup{
  width: 100%;
  height: 100%;
}
.video-content{
  width: 100%;
  height: 100%;
  position: relative;
  & video{
    width: 100%;
    height: 100%;
    display: block;
  }
  & img{
    width: 100%;
    height: 100%;
    display: block;
  }
  & .videoPlayBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 30px;
    align-items: center;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 100;
    & .videoBtn{
      width: 53px;
      height: 53px;
      display: block;
    }
    & .videoTextBtn{
      width: 200px;
      height: 45px;
      margin: 0 auto;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.full-screen-video {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  opacity: 1;
}
</style>
